import { createStore, applyMiddleware } from "redux";
import thunk from "redux-thunk";
import { save, load } from "redux-localstorage-simple";
import { composeWithDevTools } from "redux-devtools-extension";
import rootReducer from "./reducers/rootReducer";
import { fetchDynamicPages } from "./actions/dynamicPagesActions";
import { fetchSite } from "./actions/siteActions";
import { environment } from "../environment";
import { fetchRootPage } from "./actions/rootPageActions";
import { fetchBrand } from "./actions/brandActions";

export const store = createStore(rootReducer, load(), composeWithDevTools(applyMiddleware(thunk, save())));

store.dispatch(fetchSite(environment.APP_BASE));
store.dispatch(fetchRootPage(environment.APP_BASE));
store.dispatch(fetchBrand());
store.dispatch(fetchDynamicPages());
